module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                Tytuł\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'title',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Status\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Utworzono\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'created_at',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Adresaci\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n                Akcje\n            ")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.messages.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('td', [_c('message-status', {
      attrs: {
        "status": item.status
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.created_at_formated) + "\n            ")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                    Wysyłka do:\n                    "), _c('message-send-to-info', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n                    W grupach: "), _vm._l((item.email_groups), function(g) {
      return _c('a', {
        staticClass: "badge",
        on: {
          "click": function($event) {
            _vm.$router.push({
              name: 'admin.email-groups.show',
              params: {
                id: g.id
              }
            })
          }
        }
      }, [_vm._v(_vm._s(g.name))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary",
        "disabled": item.status != 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.messages.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76108116","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/List.vue
// module id = 273
// module chunks = 0